<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

defineOptions({ name: 'LocationPermissionDialog' });

const props = withDefaults(
  defineProps<{
    visible?: boolean;
  }>(),
  { visible: false }
);

defineEmits<{
  agree: [];
  disagree: [];
}>();

const { t } = useI18n();
const dialog = ref(props.visible);

watch(
  () => props.visible,
  visible => {
    dialog.value = visible;
  }
);
</script>

<template>
  <v-dialog v-model="dialog" persistent>
    <v-card class="comet-i18n-exclude">
      <v-card-title class="pl-6 pt-6">{{ t('locationPermission.title') }}</v-card-title>
      <v-card-text>
        {{ t('locationPermission.body') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$emit('disagree')">
          {{ t('locationPermission.disagree') }}
        </v-btn>
        <v-btn color="primary" @click="$emit('agree')">{{ t('locationPermission.agree') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
